module.exports = __webpack_public_path__ + "img/card-transactions.3bf710ff.svg";